var VehicleService = /** @class */ (function () {
    function VehicleService($interval, $rootScope, mKioskService) {
        this.$interval = $interval;
        this.$rootScope = $rootScope;
        this.mKioskService = mKioskService;
        this.queues = [];
        this.delay = 60000; // 1 minutes
    }
    VehicleService.prototype.onVehiclesChange = function (func) {
        var _this = this;
        this.queues.push(func);
        if (this.queues.length === 1) {
            this.stopTime = this.$interval(function () {
                _this.onInterval();
            }, this.delay);
        }
        return function () {
            _this.unRegister(func);
        };
    };
    VehicleService.prototype.unRegister = function (func) {
        var pos = this.queues.indexOf(func);
        this.queues.splice(pos, 1);
        if (this.queues.length === 0) {
            this.$interval.cancel(this.stopTime);
        }
    };
    VehicleService.prototype.onInterval = function () {
        var _this = this;
        this.getVehicles().then(function (vehicles) {
            _this.queues.forEach(function (func) {
                func(vehicles);
            });
        });
    };
    VehicleService.prototype.getVehicles = function () {
        return this.mKioskService.getMyVehicles();
    };
    VehicleService.$inject = ['$interval', '$rootScope', 'MKioskService'];
    return VehicleService;
}());
angular.module('shared').service('VehicleService', VehicleService);
